import React from "react";
import { GlobeIcon, LockIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
type PriceBlockProps = {
  heading: string;
  label: string;
  oldPrice?: string;
  newPrice?: string;
  note?: string;
  id?: string;
};
export function PriceBlock({
  heading,
  label,
  oldPrice = "$180 USD",
  newPrice = "$27",
  note = "One-time payment · Digital collection · No recurring subscription",
  id
}: PriceBlockProps) {
  return <div className="mx-auto w-full max-w-xl rounded-3xl border-4 border-cta bg-white p-5 text-ink shadow-[0_20px_50px_-20px_rgba(7,27,51,0.45)] sm:p-7" data-id="element-43" data-mp="1g6etko6guc7x">
      <h3 className="text-center font-display text-xl font-black uppercase leading-tight sm:text-2xl" data-id="element-44" data-mp="1p506a2p9ax0s">{heading}</h3>
      <div className="mt-4 flex items-end justify-center gap-3" data-id="element-45" data-mp="11f5u7ncrhchl">
        <span className="pb-3 text-xl font-bold text-alert line-through decoration-2" data-id="element-46" data-mp="wguj79aqcvxs">{oldPrice}</span>
        <span className="font-display text-7xl font-black leading-none text-mint" data-id="element-47" data-mp="1rzrni02k9138">{newPrice}</span>
        <span className="pb-2 font-display text-xl font-extrabold text-mint" data-id="element-48" data-mp="1wyunv77lij4v">USD</span>
      </div>
      <div className="mt-5" data-id="element-49" data-mp="21pktmljxoo03">
        <CtaButton label={label} id={id} data-id="element-50" data-mp="21pb757y3kyz5" />
      </div>
      <p className="mt-3 text-center text-sm font-medium text-muted" data-id="element-51" data-mp="21rxb6xls4wcm">{note}</p>
      <div className="mt-5 space-y-3" data-id="element-52" data-mp="26nur52t4s0ov">
        <Countdown data-id="element-53" data-mp="1915k2ejkmxw5" />
        <ScarcityBar data-id="element-54" data-mp="191p3y0ss7wct" />
      </div>
      <div className="mt-4 flex items-start gap-3 rounded-2xl bg-sky p-3.5" data-id="element-55" data-mp="192qd1zq8m8rw">
        <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-56" data-mp="1e0rvqjjr462u" />
        <p className="text-sm leading-snug text-ink" data-id="element-57" data-mp="1iytndsv8tdpx">
          <strong data-id="element-58" data-mp="1j1fvpupyjx97">Automatic currency conversion:</strong> the price is converted to your local currency at checkout.
        </p>
      </div>
      <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-semibold text-muted" data-id="element-59" data-mp="2uf06zhz2msz6">
        <li className="flex items-center gap-1.5" data-id="element-60" data-mp="2yeipy87c0tzd"><LockIcon className="h-4 w-4 text-mint" aria-hidden="true" data-id="element-61" data-mp="2yhoi5wb9cbzb" />Secure checkout</li>
        <li className="flex items-center gap-1.5" data-id="element-62" data-mp="zd6ij96kn49a"><ShieldCheckIcon className="h-4 w-4 text-mint" aria-hidden="true" data-id="element-63" data-mp="ucilo6vnvt75" />Digital product</li>
        <li className="flex items-center gap-1.5" data-id="element-64" data-mp="18ca2sghh5ppd"><GlobeIcon className="h-4 w-4 text-mint" aria-hidden="true" data-id="element-65" data-mp="18b8idlekjquz" />Automatic currency conversion</li>
      </ul>
    </div>;
}